import * as React from 'react'

const useAudioContext = () => {
  const ctxRef = React.useRef<AudioContext | null>(null)
  if (!ctxRef.current) {
    ctxRef.current = typeof AudioContext !== 'undefined' ? new AudioContext() : null
  }
  return ctxRef.current
}

const playTone = (ctx: AudioContext | null, frequency: number, duration = 0.2) => {
  if (!ctx) return
  const oscillator = ctx.createOscillator()
  const gain = ctx.createGain()
  oscillator.connect(gain)
  gain.connect(ctx.destination)
  oscillator.frequency.value = frequency
  oscillator.type = 'triangle'
  gain.gain.setValueAtTime(0.2, ctx.currentTime)
  gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + duration)
  oscillator.start()
  oscillator.stop(ctx.currentTime + duration)
}

const useGameSounds = () => {
  const ctx = useAudioContext()

  const playAnswerClick = React.useCallback(() => {
    playTone(ctx, 440, 0.15)
  }, [ctx])

  const playCorrectAnswer = React.useCallback(() => {
    playTone(ctx, 660, 0.4)
    playTone(ctx, 880, 0.5)
  }, [ctx])

  const playWrongAnswer = React.useCallback(() => {
    playTone(ctx, 220, 0.45)
  }, [ctx])

  const playReveal = React.useCallback(() => {
    playTone(ctx, 320, 0.6)
    setTimeout(() => playTone(ctx, 520, 0.6), 200)
  }, [ctx])

  return {
    playAnswerClick,
    playCorrectAnswer,
    playWrongAnswer,
    playReveal,
  }
}

export default useGameSounds
